import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';

export const paymentTypeValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const type = control.get('payment_type');

    if (type.value == '1') {
        // console.log('type.value = 1');
        return (control.get('cc_number').value.toString().length > 0
            && control.get('cc_cvv2').value.toString().length > 0
            && control.get('cc_exp_year').value.toString().length > 0
            && control.get('cc_exp_month').value.toString().length > 0) ? null : { 'required_cc': true };
    } else if (type.value == '10') {
        // console.log('type.value = 10');
        return control.get('paypal_address').value ? null : { 'required_paypal': true };
    } else if (type.value == '20') {
        return null; //bitcoin no validation
    } else {
        // console.log('no type value');
        return  { 'required': true };
    }
};

export function validateCC(control: AbstractControl): ValidationErrors | null {
    const cardnumber = String(control.value).replace (/\s/g, '');
    if (control.pristine) {
        console.log('pristine, return');
        return null;
    }
     // Array to hold the permitted card characteristics
     const cards = [];
     let i = 0;
     // Define the cards we support. You may add addtional card types as follows.
     //  Name:         As in the selection box of the form -
     //                must be same as user's
     //  Length:       List of possible valid lengths of the card number for the card
     //  prefixes:     List of possible prefixes for the card
     //  checkdigit:   Boolean to say whether there is a check digit

     cards [0] = {name: 'Visa',
               length: '16',
               prefixes: '4',
               checkdigit: true,
               regex: /^4\d{3}-?\d{4}-?\d{4}-?\d{4}$/ };
    cards [1] = {name: 'MasterCard',
               length: '16',
               prefixes: '51,52,53,54,55,22,23,24,25,26,27',
               checkdigit: true,
               regex: /^5[1-5]\d{2}-?\d{4}-?\d{4}-?\d{4}$|^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d\d|7(?:[01]\d|20))-?\d{4}-?\d{4}-?\d{4}$/};


     // cards [2] = {name: "DinersClub",
     //              length: "14,16",
     //              prefixes: "36,38,54,55",
     //              checkdigit: true};
     // cards [3] = {name: "CarteBlanche",
     //              length: "14",
     //              prefixes: "300,301,302,303,304,305",
     //              checkdigit: true};
     // cards [4] = {name: "AmEx",
     //              length: "15",
     //              prefixes: "34,37",
     //              checkdigit: true};
     // cards [5] = {name: "Discover",
     //              length: "16",
     //              prefixes: "6011,622,64,65",
     //              checkdigit: true};
     // cards [6] = {name: "JCB",
     //              length: "16",
     //              prefixes: "35",
     //              checkdigit: true};
     // cards [7] = {name: "enRoute",
     //              length: "15",
     //              prefixes: "2014,2149",
     //              checkdigit: true};
     // cards [8] = {name: "Solo",
     //              length: "16,18,19",
     //              prefixes: "6334,6767",
     //              checkdigit: true};
     // cards [9] = {name: "Switch",
     //              length: "16,18,19",
     //              prefixes: "4903,4905,4911,4936,564182,633110,6333,6759",
     //              checkdigit: true};
     // cards [10] = {name: "Maestro",
     //              length: "12,13,14,15,16,18,19",
     //              prefixes: "5018,5020,5038,6304,6759,6761,6762,6763",
     //              checkdigit: true};
     // cards [11] = {name: "VisaElectron",
     //              length: "16",
     //              prefixes: "4026,417500,4508,4844,4913,4917",
     //              checkdigit: true};
     // cards [12] = {name: "LaserCard",
     //              length: "16,17,18,19",
     //              prefixes: "6304,6706,6771,6709",
     //              checkdigit: true};


     // Establish card type
    let cardType = -1;
    if (String(cardnumber).charAt(0) == '4') {
        // visa
        cardType = 0;
     } else if (String(cardnumber).charAt(0) == '5' || String(cardnumber).charAt(0) == '2') {
        // mastercard
        cardType = 1;
    } else {
        // If card type not found, report an error
        return { invalidFormat: true };
    }

    if (!cards[cardType].regex.test(cardnumber)) {
        return { invalidFormat: true };
    }

    // Now remove any spaces from the credit card number

    // Check that the number is numeric
    const cardNo = cardnumber;
    const cardexp = /^[0-9]{13,19}$/;
    if (!cardexp.exec(cardNo))  {
        return { invalidFormat: true };
    }

    // Now check the modulus 10 check digit - if required
    if (cards[cardType].checkdigit) {
        let checksum = 0;    // running checksum total
        let j = 1;           // takes value of 1 or 2

        // Process each digit one by one starting at the right
        let calc;
        for (i = cardNo.length - 1; i >= 0; i--) {
            // Extract the next digit and multiply by 1 or 2
            // on alternative digits.
            calc = Number(cardNo.charAt(i)) * j;

            // If the result is in two digits add 1 to the checksum total
            if (calc > 9) {
                checksum = checksum + 1;
                calc = calc - 10;
            }

            // Add the units element to the checksum total
            checksum = checksum + calc;
            // Switch the value of j
            if (j == 1) {j = 2; } else {j = 1; }
        }

        // All done - if checksum is divisible by 10, it is a valid modulus 10.
        // If not, report an error.
        if (checksum % 10 !== 0) {
            return { invalidFormat: true };

        }
    }

    // Check it's not a spam number
    if (cardNo == '5490997771092064') {
        return { blacklisted: true };
    }

    // The following are the card-specific checks we undertake.
    let LengthValid = false;
    let PrefixValid = false;
    // var undefined;

    // We use these for holding the valid lengths and prefixes of a card type
    let prefix = [];
    let lengths = [];

    // Load an array with the valid prefixes for this card
    prefix = cards[cardType].prefixes.split(',');

    // Now see if any of them match what we have in the card number
    for (i = 0; i < prefix.length; i++) {
        const exp = new RegExp ('^' + prefix[i]);
        if (exp.test (cardNo)) {
            PrefixValid = true;
        }
    }
     // If it isn't a valid prefix there's no point at looking at the length
    if (!PrefixValid) {
        return { invalidFormat: true };
    }

     // See if the length is valid for this card
    lengths = cards[cardType].length.split(',');
    for (let it = 0; it < lengths.length; it++) {
        if (cardNo.length == parseInt(lengths[it], 10)) {
            LengthValid = true;
        }
    }

    // See if all is OK by seeing if the length was valid. We only check
    // the length if all else was hunky dory.
    if (!LengthValid) {
        return { invalidFormat: true };
    }

    return null;
}


export function validateQst(control: AbstractControl): ValidationErrors | null {
    const qst = String(control.value).replace (/\s/g, '');
    console.log(control);
    if (control.pristine || control.value == '') {
        return null;
    }
    return (/[0-9]{10}[tT][qQ][0-9]{4}/.test(qst))
        ? null
        : { invalid_qst: true };
}

export function requiredWithoutWhitespaces(control: AbstractControl): ValidationErrors | null {
    const isValid = control.value && control.value.trim().length > 0;
    return isValid ? null : { 'required': true };
}